export const ProfessionalDisciplinesResolver = {
    disciplines: () => [
        {
            name: 'Sample Discipline',
            roles: ['Sample Role 1', 'Sample Role 2'],
        },
        {
            name: 'Architectural',
            roles: ['Architect', 'Project Manager'],
        },
    ],
}
